import { CONSORS_NATIONALITY_ISO_EU, CONSORS_NATIONALITY_ISO_OTHERS } from 'cpool-constants';
import { z } from 'zod';

export const schemaConsorsNationalityISOGermany = z.literal('276');
export type SchemaConsorsNationalityISOGermany = z.infer<typeof schemaConsorsNationalityISOGermany>;

export const schemaConsorsNationalityISOAustria = z.literal('040');
export type SchemaConsorsNationalityISOAustria = z.infer<typeof schemaConsorsNationalityISOAustria>;

export const schemaConsorsNationalityISOEU = z.nativeEnum(CONSORS_NATIONALITY_ISO_EU);
export type SchemaConsorsEUNationality = z.infer<typeof schemaConsorsNationalityISOEU>;

export const schemaConsorsNationalityISOOthers = z.nativeEnum(CONSORS_NATIONALITY_ISO_OTHERS);
export type SchemaConsorsNationalityISOOthers = z.infer<typeof schemaConsorsNationalityISOOthers>;
